module.exports = __webpack_public_path__ + "components/star-rating/static/white/3-36c9098b21956feecb96ed901aaf1087.svg";